var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.594 2.5h-3.656L10.742.953C10.426.531 9.934.25 9.406.25H6.594c-.563 0-1.055.281-1.371.703L4.063 2.5H.405a.277.277 0 00-.281.281v.563c0 .176.105.281.281.281h.633l1.195 13.113a1.65 1.65 0 001.653 1.512h8.191a1.65 1.65 0 001.652-1.512l1.196-13.113h.668c.14 0 .281-.105.281-.281V2.78c0-.14-.14-.281-.281-.281zm-9.457-.879c.105-.14.246-.21.457-.246h2.812a.652.652 0 01.422.246l.703.879H5.47l.668-.879zm6.504 15.012a.568.568 0 01-.563.492H3.887c-.282 0-.528-.21-.528-.492L2.2 3.625h11.602l-1.16 13.008z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrey);
export default __webpack_public_path__ + "static/media/trash-grey.0ed8a6c577aab7ef6d12b6ad907639a1.svg";
export { ForwardRef as ReactComponent };